/* eslint-disable no-undef */

// Routes
import { ClientRoutes } from '../Routes';

// Moment
import Moment from 'moment';

// Emitter
var { EventEmitter } = require('fbemitter');
var emitter = new EventEmitter();

/* Sockets */
var io = require('socket.io-client');
var socket = null;

/* Prices Objects */

// object where prices stored in nested hierarchy -> best for looking up prices in exchange+quotecurrency
var PRICES = {}; 

var LOADED = false;

/**********************************************************
 *  Init
 **********************************************************/

// Setup socket listening
// Subscribe to topics
// configure emitter
function init() {

    console.log('PricingStore Initialized');

    var socket = null;

    // Configure Socket Connection
    configureSocket()
        .then( (connection) => {

            socket = connection;

            return refreshPrices(); // Retrieve Latest Prices

        })
        .then( (prices) => {

            // Build Topics if prices are good
            if(prices != null) {
                return buildTopics(prices);
            }
            else {
                throw new Error('Failed Socket Connection to Pricing Service');
            }

        })
        .then( (topics) => {

            if(socket !== null)
                streamPrices(socket, topics);
            else
                throw new Error('Failed Socket Connection to Pricing Service');

            return;

        })
        .then( () => {

            startCacheInterval();

        })
        .catch( (error) => {
            console.log('PricingStore Error: ' + error.message);
        });

}

/**********************************************************
 *  Socket Functions
 **********************************************************/

 // Connects socket to server and validates with user info
function configureSocket() {

    return new Promise( (resolve, reject) => {

        ClientRoutes.getSocketConnection()
            .then( (socket) => {

                //var sock = io.connect('ws://ec2-34-210-220-99.us-west-2.compute.amazonaws.com:2000/');
                try {
                    const sock = io.connect(socket, {forceNew:true, autoConnect: true});

                    // validate
                    //var userId = 'unknown machine';
                    //if(UserProfileStore != null && UserProfileStore.getUser() !== null)
                        //userId =  UserProfileStore.getUser();

                    sock.on('connect', function() {
                        console.log('Connected to App Server sockets!');
                        resolve(sock);
                    });

                    sock.on('error', function (error) {
                        console.log('Socket Error: ' + error);
                    });
        
                    sock.on('reconnect', (attemptNumber) => {
                        console.log('Re-Connected to App Server Sockets on attempt ' + attemptNumber);
                    });
        
                    sock.on('connect_timeout', (timeout) => {
                        console.log('Connect_TimeOut on App Server Sockets...');
                    });
        
                    sock.on('disconnect', function() {
                        console.log('Disconnected from App Server Sockets...');
                    });
                }
                catch(error) {
                    reject(error);
                }
            })
            .catch( (error) => {

                reject(error);

            });
    
    });

    

}


// Closes the current socket
function closeSocket() {

    socket.disconnect();
    socket = null;

}

/**********************************************************
 *  Price Streaming Functions
 **********************************************************/

// Listen for price updates on socket
function streamPrices(socket, topics) {

    for(let topic of topics) {

        socket.on(topic, function(priceObj) {

            storePrice(priceObj);
            emitPrice(priceObj);
            
        });

    }

}


// Given a price object, insert it into master price object
function storePrice(priceObj) {

    // Prices Object
    const details = translatePriceTopic(priceObj.id);
    PRICES[details.exchange][details.quote][details.ticker] = priceObj;

}


// Emits the given price object on its id
function emitPrice(priceObj) {

    emitter.emit(priceObj.id, priceObj);

}


// Every 5 minutes, cache the main prices object
function startCacheInterval() {

    const fiveMins = 1000 * 60 * 5;

    setInterval(cachePrices, fiveMins);

}


// Cache the main prices object and update the cachetime
function cachePrices() {

    //console.log('PricingStore.cachePrices()');

    localStorage.setItem('prices', JSON.stringify(PRICES));
    localStorage.setItem('settings_prices_cachetime', JSON.stringify(Moment().valueOf()));

}


/**********************************************************
 *  Emitter Functions
 **********************************************************/

// Returns the emitter
function getEmitter(subscriptions) {

    if(subscriptions.length > 0) {
        
        for(let sub of subscriptions) {
            sub.remove();
        }

        return emitter;

    }
    else {

        return emitter;

    }
        
};

/**********************************************************
 *  Price Functions
 **********************************************************/

 // Refreshes all Prices
 function refreshPrices() { 

    return new Promise( (resolve, reject) => {

        ClientRoutes.getAllPrices()
            .then( (latestPrices) => {
                
                PRICES = buildPrices(latestPrices);
                LOADED = true;

                localStorage.setItem('prices', JSON.stringify(PRICES));
                localStorage.setItem('settings_prices_cachetime', JSON.stringify(Moment().valueOf()));

                resolve(latestPrices);

            }).catch( (error) => {

                reject(error);

            });
    });

 }


 // Given a set of latest prices, build and cache the topics
 function buildTopics(latestPrices) {

    // build topics and return for streaming
    var topics = [];

    for(let topic of Object.keys(latestPrices)) {
        topics.push(topic);
    }

    localStorage.setItem('topics', JSON.stringify(topics));

    return topics;

 }


 // Return the latest price for a given topic
 function getPrice(topic) {

    return new Promise( (resolve, reject) => {

        // If prices are loaded, return instantly
        if(LOADED) {
            const details = translatePriceTopic(topic);
            resolve(PRICES[details.exchange][details.quote][details.ticker]);
        }
        // Otherwise, refresh prices and return
        else {

            refreshPrices()
                .then( (latestPrices) => {

                    resolve(latestPrices[topic]);

                })
                .catch( (error) => {

                    reject(error);

                });

        }

    });

 }


 // Returns the market cap details for the given quote currency
 function getMarketCap(count, currency) {

    return ClientRoutes.getMarketCap(count, currency)
        .then( (marketcaps) => {
            return marketcaps;
        });

 }


// Given the standard array of prices, build a master object
// for quicker retrievals by exchange+quotecurrency
function buildPrices(prices) {

    var newPrices = {};
    
    for(let [topic, price] of Object.entries(prices)) {

        var details = translatePriceTopic(topic);

        // Add exchange, quote and ticker
        if(!newPrices.hasOwnProperty(details.exchange)) {

            newPrices[details.exchange] = {};
            newPrices[details.exchange][details.quote] = {};
            newPrices[details.exchange][details.quote][details.ticker] = {
                'price' : price.price,
                'change' : price.change,
                'timestamp' : price.timestamp,
                'id' : topic,
                'name' : price.name
            };

        }
        else {

            // Add quote and ticker
            if(!newPrices[details.exchange].hasOwnProperty(details.quote)) {

                newPrices[details.exchange][details.quote] = {};
                const newTickerObj = {
                    'price' : price.price,
                    'change' : price.change,
                    'timestamp' : price.timestamp,
                    'id' : topic,
                    'name' : price.name
                };

                newPrices[details.exchange][details.quote][details.ticker] = newTickerObj;

            }
            else {

                newPrices[details.exchange][details.quote][details.ticker] = {
                    'price' : price.price,
                    'change' : price.change,
                    'timestamp' : price.timestamp,
                    'id' : topic,
                    'name' : price.name
                };

            }

        }

    }

    return newPrices;

}


// Given an exchange and quotecurrency, return the set of all
// relevant prices
function getExchangePricesByQuote(exchange, quoteCurrency) {

    return new Promise( (resolve, reject) => {

        if(Object.keys(PRICES).length > 0) {
            resolve(PRICES[exchange][quoteCurrency]);
        }
        else {

            refreshPrices()
                .then( (latestPrices) => {

                    resolve(PRICES[exchange][quoteCurrency]);

                }).catch( (error) => {

                    reject(error);

                });

        }

    });

}

/**********************************************************
 *  Price Helper Functions
 **********************************************************/

// Given a topic, return an object with ticker,
// exchange and quote inside of it
function translatePriceTopic(topic) {
    
    var components = topic.split('-');

    return {
        'ticker' : components[0],
        'exchange' : components[1],
        'quote' : components[2]
    };

}


/**********************************************************
 *  Price Settings Functions
 **********************************************************/

 // Looks for the last exchange cached and returns it
function getExchange() {
    
    const exchange = localStorage.getItem('settings_prices_exchange');

    if(exchange != null) {
        return JSON.parse(exchange);
    }
    else {
        const defaultExchange = 'Kraken';
        setExchange(defaultExchange);
        return defaultExchange;
    }
        

}


// Caches the given exchange
function setExchange(exchange) {

    localStorage.setItem('settings_prices_exchange', JSON.stringify(exchange));

}


// Looks for the last quote currency cached and returns it
function getQuoteCurrency() {
    
    const quoteCurrency = localStorage.getItem('settings_prices_quotecurrency');

    if(quoteCurrency != null) {
        return JSON.parse(quoteCurrency);
    }
    else {
        const defaultQuoteCurrency = 'USD';
        setQuoteCurrency(defaultQuoteCurrency);
        return defaultQuoteCurrency;
    }

}


// Caches the given quote currency
function setQuoteCurrency(quoteCurrency) {

    localStorage.setItem('settings_prices_quotecurrency', JSON.stringify(quoteCurrency));

}


// Returns the last active tab
function getActivePricesTab() {

    const tab = localStorage.getItem('settings_prices_activetab');

    if(tab != null) {
        return JSON.parse(tab);
    }
    else {
        const defaultTab = 'prices';
        setActivePricesTab(defaultTab);
        return defaultTab;
    }

}


// Caches the given quote currency
function setActivePricesTab(tab) {

    localStorage.setItem('settings_prices_activetab', JSON.stringify(tab));

}

 /**********************************************************
 *  Caching Functions
 **********************************************************/

const PricingStore = { init, closeSocket, getEmitter, streamPrices, getPrice, refreshPrices,
getMarketCap, getExchange, setExchange, getQuoteCurrency, setQuoteCurrency, getActivePricesTab, setActivePricesTab, getExchangePricesByQuote  };
export default PricingStore;






// WEBPACK FOOTER //
// ./src/Stores/PricingStore.js